import { NgModule } from '@angular/core';
import { UIModule } from '../../ui/ui.module';
import { SharedModule } from "../../modules/shared/shared.module";
import { ReactiveFormsModule } from "@angular/forms";
import { NzShareModule } from '../../nz/nz-share.module';
import { TextMaskModule } from 'angular2-text-mask';
import { JitsiComponent } from './jitsi.component';

@NgModule({
  declarations: [
    JitsiComponent,
  ],
  exports: [
    JitsiComponent
  ],
  imports: [
    UIModule,
    SharedModule,
    ReactiveFormsModule,
    NzShareModule,
    TextMaskModule
  ],
})
export class JitsiModule { }
